import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccd380a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "q-pa-md"
}
const _hoisted_2 = { class: "q-px-sm justified-center" }
const _hoisted_3 = {
  key: 2,
  class: "q-pa-md"
}
const _hoisted_4 = { class: "q-px-sm justified-center" }
const _hoisted_5 = { class: "q-mt-md q-mb-sm q-mx-md" }
const _hoisted_6 = { class: "scroll q-px-lg row q-gutter-y-sm justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_brief_item = _resolveComponent("brief-item")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createElementBlock("div", {
    onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.goNextStep && _ctx.goNextStep(...args)), ["enter"])),
    id: "select-brief"
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_q_spinner, {
          key: 0,
          class: "q-mx-lg",
          color: "primary",
          size: "40px"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_q_toolbar, _normalizeProps(_guardReactiveProps(_ctx.TEXT_QUATERNARY_TITLE)), {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t(`LEAD_CREATION_STEPS.STEP-${_ctx.step}`, { a: _ctx.t('BRIEF.LOW.ART'), brief: _ctx.t('BRIEF.LOW.SING') })), 1)
      ]),
      _: 1
    }, 16),
    (_ctx.currentSelectedBrief)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_item_label, _mergeProps({ class: "q-px-sm q-mb-sm" }, _ctx.TEXT_CARD_BODY), {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('CURRENT_BRIEF', { brief: _ctx.t('BRIEF.LOW.SING') })), 1)
            ]),
            _: 1
          }, 16),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_brief_item, {
              brief: _ctx.currentSelectedBrief,
              "selected-brief": _ctx.selectedBrief,
              onSelectedBrief: _ctx.selectBrief,
              "on@nextStepFromItem": _ctx.goNextStep
            }, null, 8, ["brief", "selected-brief", "onSelectedBrief", "on@nextStepFromItem"])
          ])
        ]))
      : (_ctx.defaultBrief)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_q_item_label, _mergeProps({ class: "q-px-sm q-mb-sm" }, _ctx.TEXT_CARD_BODY), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('DEFAULT_BRIEF', { brief: _ctx.t('BRIEF.LOW.SING') })), 1)
              ]),
              _: 1
            }, 16),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_brief_item, {
                brief: _ctx.defaultBrief,
                "selected-brief": _ctx.selectedBrief,
                onSelectedBrief: _ctx.selectBrief,
                "on@nextStepFromItem": _ctx.goNextStep
              }, null, 8, ["brief", "selected-brief", "onSelectedBrief", "on@nextStepFromItem"])
            ])
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_q_toolbar, null, {
      default: _withCtx(() => [
        _createVNode(_component_q_input, _mergeProps({
          label: _ctx.t('BRIEF_NAME', { Brief: _ctx.t('BRIEF.CAP.SING') }),
          placeholder: _ctx.t('SEARCH_BRIEF_PLACEHOLDER', { brief: _ctx.t('BRIEF.LOW.SING') }),
          autofocus: "",
          class: "full-width",
          clearable: "",
          maxlength: _ctx.MAX_LENGTH.BRIEF.NAME
        }, _ctx.INPUT_LG, {
          modelValue: _ctx.searchText,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
            _ctx.getSuggestedBriefs
          ]
        }), {
          prepend: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: _ctx.ICONS_NAME.SEARCH_OUTLINE
            }, null, 8, ["name"])
          ]),
          _: 1
        }, 16, ["label", "placeholder", "maxlength", "modelValue", "onUpdate:modelValue"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_q_item_label, _mergeProps({ class: "q-px-sm" }, _ctx.TEXT_CARD_BODY), {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.searchResultTitle), 1)
        ]),
        _: 1
      }, 16)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!_ctx.myBriefList || !_ctx.myBriefList.length)
        ? (_openBlock(), _createBlock(_component_q_item, {
            key: 0,
            class: "q-px-sm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, {
                    class: "text-caption",
                    lines: "1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('NOT_FOUND', { brief: _ctx.t('BRIEF.LOW.PLUR') })), 1)
                    ]),
                    _: 1
                  }),
                  (!_ctx.defaultBrief)
                    ? (_openBlock(), _createBlock(_component_q_item_label, {
                        key: 0,
                        caption: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('NOT_DEFAULT_BRIEF_FOUND')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.myBriefList, (brief) => {
            return (_openBlock(), _createBlock(_component_brief_item, {
              brief: brief,
              key: brief.dobjId,
              "selected-brief": _ctx.selectedBrief,
              onSelectedBrief: _ctx.selectBrief,
              "on@nextStepFromItem": _ctx.goNextStep
            }, null, 8, ["brief", "selected-brief", "onSelectedBrief", "on@nextStepFromItem"]))
          }), 128))
    ])
  ], 32))
}